import React from "react"
import {FunctionComponent} from "react"
import ComponentWrapper from "../../../common/components/ComponentWrapper"
import {useNavigate} from "react-router-dom"
import {useCustomer} from "../../../common/contexts/CustomerContext"
import {useUserPreferences} from "../../../common/contexts/UserPreferencesContext"
import Button from "@murphy-frontend/web-core/components/Button"
import {TbHierarchy3} from "react-icons/tb"
import {IconContext} from "react-icons"

const TMSWelcome: FunctionComponent = () => {
	const navigate = useNavigate()
	const {translations} = useUserPreferences()

	return (
		<ComponentWrapper active={3}>
			<section className='header-btns'></section>
			<section className='general-wrapper'>
				<IconContext.Provider value={{className: "tmswelcome-icon"}}>
					<TbHierarchy3 />
				</IconContext.Provider>
				<h1 className='assessment_title'>{translations.questionIntro || 'Welcome to The Crisis Framework'}</h1>
				<p className='assessment_subttext'>
					{translations.questionStarter || 'Get started by taking your first assessment questionnaire on your organization’s crisis management capacity.'}
				</p>
				<Button
					buttonStyle={"btn--primary"}
					buttonSize={"btn--medium"}
					onClick={() => navigate(`/startassessment`)}
				>
					{translations.startAssessment}
				</Button>
				<p className='assessment_subttext'>{translations.questionLenght || '25 mins to complete.'}</p>
				<Button buttonSize={"btn--medium"} isLightButton={true} onClick={() => navigate(`/tmsparentdashboard`)}>
					{translations.skipAssessment}
				</Button>
			</section>
		</ComponentWrapper>
	)
}

export default TMSWelcome
